<a class="close-icon" [mat-dialog-close]="">
  <mat-icon>close</mat-icon>
</a>
<h2 mat-dialog-title>
  {{ "brand.partnerImportList.matching.errorsDialog.title" | translate }}
</h2>
<mat-dialog-content class="content">
  <div class="report" *ngFor="let row of errors">
    <h3 class="report__business-name">
      <span class="report__row-number">#{{ row.lineNumber }}</span>
      {{
        row.businessName ??
          ("brand.partnerImportList.matching.errorsDialog.notAvailable"
            | translate)
      }}
    </h3>
    <table class="report__errors">
      <thead>
        <td class="report__col-column">
          {{
            "brand.partnerImportList.matching.errorsDialog.column" | translate
          }}
        </td>
        <td>
          {{
            "brand.partnerImportList.matching.errorsDialog.problem" | translate
          }}
        </td>
      </thead>
      <tbody>
        <tr *ngFor="let item of row.errors">
          <td class="report__column">
            <span class="report__column-idx">{{ item.column.index }}</span>
            {{
              item.column.name ??
                "brand.partnerImportList.matching.errorsDialog.notAvailable"
                | translate
            }}
          </td>
          <td>
            {{
              "brand.partnerImportList.matching.errorsDialog.errors." +
                item.error | translate
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn--primary" [mat-dialog-close]="">
    {{ "shared.close" | translate }}
  </button>
</mat-dialog-actions>
